/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Snapchat Conversions API helpers (Pro)
 *
 * The user data, click ID and base payload the Conversions API events carry.
 * The adapter falls back to a base without user data when
 * pmw.getSnapchatS2SBaseData is absent, which is the case on a free build.
 * */

(function (pmw, undefined) {

	/**
	 * Get Snapchat user data
	 * https://docs.snap.com/api/marketing-api/Conversions-API/Parameters#user-data-parameters
	 *
	 * @return {{}}
	 */
	pmw.getSnapchatUserData = () => {
		let data = {}

		// add user_agent from browser
		data.client_user_agent = navigator.userAgent

		// add sc_click_id: the ScCid landing parameter
		// https://developers.snap.com/api/marketing-api/Conversions-API/Parameters
		const scCid = snapchatGetScCid()

		if (scCid) {
			data.sc_click_id = scCid
		}

		// add sc_cookie1: the Snap pixel's own first-party user cookie.
		// _scid_r is the companion cookie newer scevent.min.js builds write
		// alongside _scid, and is only consulted when _scid itself is missing.
		const scCookie1 = normalizeScidCookieValue(pmw.getCookie("_scid") || pmw.getCookie("_scid_r"))

		if (scCookie1) {
			data.sc_cookie1 = scCookie1
		}

		if (pmwDataLayer?.pixels?.snapchat?.advanced_matching) {

			if (pmwDataLayer?.user?.email?.sha256) {
				data.em = pmwDataLayer.user.email.sha256
			}

			if (pmwDataLayer?.user?.phone?.snapchat) {
				data.ph = pmwDataLayer.user.phone.snapchat
			}

			// add first name
			if (pmwDataLayer?.user?.first_name?.snapchat) {
				data.fn = pmwDataLayer.user.first_name.snapchat
			}

			// add last name
			if (pmwDataLayer?.user?.last_name?.snapchat) {
				data.ln = pmwDataLayer.user.last_name.snapchat
			}

			// add city
			if (pmwDataLayer?.user?.city?.snapchat) {
				data.ct = pmwDataLayer.user.city.snapchat
			}

			// add state
			if (pmwDataLayer?.user?.state?.snapchat) {
				data.st = pmwDataLayer.user.state.snapchat
			}

			// add postal code
			if (pmwDataLayer?.user?.postcode?.sha256) {
				data.zp = pmwDataLayer.user.postcode.sha256
			}

			// add country
			if (pmwDataLayer?.user?.country?.snapchat) {
				data.country = pmwDataLayer.user.country.snapchat
			}

			// external_id
			if (pmwDataLayer?.user?.id?.sha256) {
				data.external_id = pmwDataLayer.user.id.sha256
			}
		}

		return data
	}

	/**
	 * Strips the single-letter version marker newer Snap pixel builds prefix
	 * onto _scid / _scid_r (for example "a.51c50086-...") and keeps the value
	 * only if what is left looks like the UUID Snap stored.
	 *
	 * @param {string|null|undefined} raw
	 * @return {string|null}
	 */
	const normalizeScidCookieValue = (raw) => {

		if (!raw) return null

		const match = /^[A-Za-z]\.(.+)$/.exec(raw)
		const value = match ? match[1] : raw

		return /^[0-9a-f-]{20,60}$/.test(value) ? value : null
	}

	const snapchatGetScCid = () => {

		// if the ScCid parameter is present in the URL get the value from there,
		// save it in the storage and return it

		// get all URL parameters

		let urlParams = new URLSearchParams(window.location.search)

		if (urlParams.has("ScCid")) {
			let scCid = urlParams.get("ScCid")
			pmw.storeData("snapchat_sc_cid", scCid)
			return scCid
		}

		// if the ScCid parameter is not present in the URL check if it is in the storage
		// and return it
		let scCid = pmw.retrieveData("snapchat_sc_cid")

		if (scCid) {
			return scCid
		}
	}

	pmw.getSnapchatS2SBaseData = () => {

		return {
			event_id: pmw.getRandomEventId(),
			// client_dedup_id : pmw.getRandomEventId(),
			event_time      : Math.floor(Date.now() / 1000), // event_time in seconds
			event_source_url: window.location.href,
			action_source   : "WEB",
			user_data       : pmw.getSnapchatUserData(),
			// integration     : "pmw",
		}
	}

}(window.pmw = window.pmw || {}));
